import { useLayoutEffect, useState } from "react";
import { getProfileInfo } from "@/pages/setup/actions";
import { useAuth } from "@/providers/auth";

const useProfileInfo = () => {
  const [profileInfo, setProfileInfo] = useState({});
  const [welcomeDialog, openWelcomeDialog] = useState(false);
  const { cognitoId, clientId, userRole } = useAuth();

  const id =
    userRole === "admin" || userRole === "auth_user" ? clientId : cognitoId;

  useLayoutEffect(() => {
    let isMounted = true;

    const getProfile = async () => {
      await getProfileInfo(id)
        .then((res) => {
          if (isMounted && res) {
            setProfileInfo(res);
            if (res.tutorial_completed === false) {
              openWelcomeDialog(true);
            }
          }
        })
        .catch((error) => {
          console.log("USE_PROFILE_INFO::GET_PROFILE_INFO::ERROR::", error);
        });
    };

    getProfile();

    return () => {
      isMounted = false;
    };
  }, []);

  return { profileInfo, welcomeDialog, openWelcomeDialog };
};

export default useProfileInfo;
